module.exports = __webpack_public_path__ + "static/media/YF87_7.f3d0df40.jpg";